import type { Params } from "../toQueryString";
import { buildPath } from "./buildPath";

export const newsletters = {
  list: ({ params = {} }: { params?: Params } = {}) =>
    buildPath("/internal_api/newsletters", params),
  create: () => buildPath("/internal_api/newsletters"),
  activationCheck: () =>
    buildPath("/internal_api/newsletters/activation_check"),
  update: ({ id }: { id: number }) =>
    buildPath(`/internal_api/newsletters/${id}`),
};
